
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pro-award-2023",
      function () {
        return require("private-next-pages/pro-award-2023.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pro-award-2023"])
      });
    }
  